import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const cartJsApi = createApi({
  reducerPath: "cartJsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_MYSHOPIFY_BASE_URL,
  }),
  endpoints: (builder) => ({
    getCartJs: builder.query({
      query: () => "/cart.js",
      providesTags: ["CartJs"],
    }),
    postCartJsAction: builder.mutation({
      query: ({ action, params = null }) => ({
        method: "POST",
        url: `/cart/${action}.js`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: params ? JSON.stringify(params) : null,
      }),
      invalidatesTags: ["CartJs"],
    }),
  }),
})

export const { useLazyGetCartJsQuery, usePostCartJsActionMutation } = cartJsApi

export default cartJsApi
